import React from 'react';
import {makeStyles} from '@material-ui/core/styles'


const useStyles=makeStyles((themes)=>({

    svg:{
        width:"50%",
        [themes.breakpoints.down('xs')]: {
            width:"100%"
          },
      
    }
    }));

export default function Path4(){
    const classes =useStyles();

    return(
        
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" className={classes.svg} viewBox="0 0 628.9 220.4">
                        <g id="_4" data-name="4" transform="translate(-394 -849)">
                            <g id="_4-2" data-name="4" transform="translate(392 846.6)">
                            <g id="Layer_1_1_">
                                <g id="Group_15" data-name="Group 15">
                                <circle id="Ellipse_1" cx="10.1" cy="10.1" r="10.1" transform="translate(2 2.4)" fill="#3c71a5"/>
                                <circle id="Ellipse_2" cx="7.8" cy="7.8" r="7.8" transform="translate(4.253 20.219) rotate(-89.529)" fill="#fff"/>
                                </g>
                                <rect id="Rectangle_1_1_" width="2.1" height="35.1" transform="translate(11 22.5)" fill="#3c71a5"/>
                            </g>
                            <g id="curve">
                                <circle id="Ellipse_1_2_" cx="10.1" cy="10.1" r="10.1" transform="translate(610.7 202.3)" fill="#3b6fa5"/>
                                <circle id="Ellipse_2_2_" cx="7.8" cy="7.8" r="7.8" transform="translate(613 204.6)" fill="#fff"/>
                                <rect id="Rectangle_1_7_" width="160.4" height="1.4" transform="translate(446.2 142.5)" fill="#3b6fa5"/>
                                <path id="Path_29" data-name="Path 29" d="M620.8,167.3a53.905,53.905,0,0,0-2-10.9c-4-12.9-11.6-13.1-12.6-13.1" fill="none" stroke="silver" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <path id="Path_30" data-name="Path 30" d="M616.5,149.8" fill="none" stroke="#00aeef" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <rect id="Rectangle_1_6_" width="1.4" height="34.3" transform="translate(620.1 166.8)" fill="#3b6fa5"/>
                                <path id="Path_31" data-name="Path 31" d="M620.8,167.3a53.905,53.905,0,0,0-2-10.9c-4-12.9-11.6-13.1-12.6-13.1" fill="none" stroke="#3b6fa5" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <circle id="Ellipse_1_1_" cx="10.1" cy="10.1" r="10.1" transform="translate(164.6 202.6)" fill="#3b6fa5"/>
                                <circle id="Ellipse_2_1_" cx="7.8" cy="7.8" r="7.8" transform="translate(166.9 204.9)" fill="#fff"/>
                                <rect id="Rectangle_1_4_" width="160.4" height="1.4" transform="translate(189 142.8)" fill="#3b6fa5"/>
                                <path id="Path_32" data-name="Path 32" d="M174.7,167.6a53.907,53.907,0,0,1,2-10.9c4-12.9,11.6-13.1,12.6-13.1" fill="none" stroke="silver" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <path id="Path_33" data-name="Path 33" d="M179,150.1" fill="none" stroke="#00aeef" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <rect id="Rectangle_1_3_" width="1.4" height="34.3" transform="translate(174 167.1)" fill="#3b6fa5"/>
                                <path id="Path_34" data-name="Path 34" d="M174.7,167.6a53.907,53.907,0,0,1,2-10.9c4-12.9,11.6-13.1,12.6-13.1" fill="none" stroke="#3b6fa5" strokeMiterlimit="10" strokeWidth="1.4"/>
                            </g>
                            <g id="top">
                                <rect id="Rectangle_1" width="358.1" height="1.4" transform="translate(12.1 56.1)" fill="#3b6fa5"/>
                                <path id="Path_35" data-name="Path 35" d="M369.4,56.7c2.2,0,19.2.2,28.2,13.1a27.775,27.775,0,0,1,4.5,10.9" fill="none" stroke="silver" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <path id="Path_36" data-name="Path 36" d="M392.5,63.3" fill="none" stroke="#00aeef" strokeMiterlimit="10" strokeWidth="1.4"/>
                                <rect id="Rectangle_1_2_" width="1.3" height="34.3" transform="translate(401.6 80.2)" fill="#3b6fa5"/>
                                <path id="Path_37" data-name="Path 37" d="M369.4,56.7c2.2,0,19.2.2,28.2,13.1a27.775,27.775,0,0,1,4.5,10.9" fill="none" stroke="#3b6fa5" strokeMiterlimit="10" strokeWidth="1.4"/>
                            </g>
                            <g id="Group_16" data-name="Group 16">
                                <g id="gmail">
                                <path id="Path_38" data-name="Path 38" d="M421.8,122.4H378.2a5.529,5.529,0,0,0-5.5,5.4v32.7a5.463,5.463,0,0,0,5.5,5.4h43.6a5.529,5.529,0,0,0,5.5-5.4V127.8A5.529,5.529,0,0,0,421.8,122.4Zm0,38.2h-5.4v-24L400,146.9l-16.4-10.4v24h-5.4V127.8h3.3L400,139.2l18.5-11.4h3.3Z" fill="#004e98"/>
                                </g>
                            </g>
                            </g>
                        </g>
            </svg>

        </div>
    )
}